module.exports = __webpack_public_path__ + "img/hqzen1.59816d21.png";